import type { IDyTemplate } from 'src/hooks';
import { ICCAsset, IProduct } from 'src/interfaces';
import { getProductPreviewUrl } from 'src/utils/getPreviewUrl';

export type VariationMap = Record<
  number,
  {
    productCode: string;
    variationCode: string;
    assetName?: string;
    showFlavors?: boolean;
  }
>;

export const getDummySingleShelfConfig = () => {
  return [
    {
      component: {
        type: 'single-shelf',
        config: {
          header: {},
          priceLabel: {
            type: 'name',
            shape: 'NONE',
          },
          subProductsDisplayFormat: {
            type: 'INLINE',
          },
          background: '',
          productList: {
            groups: {
              '1': {
                order: 1,
                products: {
                  '1': {},
                },
              },
            },
          },
          productsSource: 'DYR',
          knownCustomer: {
            header: {
              text: 'Add another fave',
            },
          },
          unknownCustomer: {
            header: {
              text: 'Want a little more?',
            },
          },
        },
        name: 'gaurav test dy',
        width: 1080,
        height: 440,
      },
    },
  ];
};

export const convertVariationMapToTemplateFormat = (
  variationMap: VariationMap,
  products: {
    product1?: IProduct;
    product2?: IProduct;
    product3?: IProduct;
  },
  assets?: ICCAsset[],
  localTemplate?: Record<string, any>,
) => {
  const mainVariationCode = variationMap[1]?.variationCode || '';

  if (!mainVariationCode) return {};

  const placeholders = import.meta.glob(
    '/src/assets/images/templatePreviewPlaceholder*.svg',
    {
      eager: true,
      import: 'default',
    },
  ) as Record<string, string>;

  const images = Object.entries(variationMap)
    .map(([variationKey, variation]) => {
      const key = `product${variationKey}` as keyof typeof products;
      const product = products[key];
      const previewUrl = product
        ? getProductPreviewUrl(product, variation.variationCode, assets, true)
        : '';

      return {
        assetName:
          previewUrl ||
          variation.assetName ||
          new URL(
            placeholders?.[
              `/src/assets/images/templatePreviewPlaceholder${variationKey}.svg`
            ],
            window.location.href,
          ).href, // absolute path
      };
    })
    .reverse();

  const getDefaultShowFlavors = (): boolean => {
    if (!localTemplate) return true;
    try {
      const firstGroup = localTemplate['1']?.groups?.['1'];
      const firstProduct = firstGroup?.products?.['1'];
      const sizes = firstProduct?.sizes;
      const sizeConfig =
        sizes?.['SIZE_TO_BE_REPLACED']?.config || sizes?.defaultConfig?.config;

      return sizeConfig?.showFlavors ?? true;
    } catch {
      return true;
    }
  };

  // Use variation's showFlavors if defined, otherwise use template default
  const showFlavors = variationMap[1]?.showFlavors ?? getDefaultShowFlavors();

  return {
    '1': [
      {
        [mainVariationCode]: {
          order: 1,
          productCode: mainVariationCode,
          variations: [
            {
              order: 1,
              productCode: mainVariationCode,
              config: {
                showFlavors,
                images,
              },
            },
          ],
        },
      },
    ],
  };
};

export const getLocalTemplate = (templateConfigs: IDyTemplate['configs']) => {
  return {
    '1': {
      groups: {
        ...templateConfigs,
      },
    },
  };
};
